<template>
  <div class="faq">
    <details v-for="(item, index) in items" :key="index" class="item">
      <summary>{{ item.q }}</summary>
      <p @click="onClick" v-html="answer(item.a)"></p>
    </details>
  </div>
</template>

<script>
  import {inline} from "@/seo/inline";
  import {followInternalLink} from "@/seo/internalLinks";

  /**
   * Questions fréquentes : éléments <details> natifs (le texte des réponses reste dans la page, lisible par les moteurs).
   * Les mêmes questions alimentent le JSON-LD FAQPage de la vue : voir schema.faqPage().
   */
  export default {
    name: 'FaqSection',
    props: {
      items: {type: Array, required: true},
    },
    methods: {
      answer(text) {
        return inline(text);
      },
      onClick(event) {
        followInternalLink(event, this.$router);
      },
    },
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.faq
  border-top 1px solid RULE

.item
  border-bottom 1px solid RULE
  summary
    display flex
    align-items center
    justify-content space-between
    gap 16px
    padding 18px 4px
    font-weight 650
    font-size 1.08rem
    cursor pointer
    list-style none
    &::-webkit-details-marker
      display none
    &::after
      content '+'
      flex none
      width 28px
      height 28px
      display inline-flex
      align-items center
      justify-content center
      border 2px solid INK
      border-radius 50%
      font-size 1.2rem
      line-height 1
      transition transform 0.2s ease, background-color 0.2s ease
  &[open] summary::after
    content '−'
    background LEMON
  p
    margin 0
    padding 0 40px 20px 4px
    max-width 70ch
    color INK_SOFT
</style>
